import React from 'react';
import { StorylineState } from "../../../store/storyline/types";
import { connect } from "react-redux";
import { RootState } from "../../../store";
import { updateParameterValue } from "../../../store/storyline/actions";
import { Slider as MaterialSlider } from "../../../shared/components";
import { DocumentedComponent } from '../../../shared/components/DocumentedComponent';

interface Props {
    storyline: StorylineState;
    updateParameterValue: typeof updateParameterValue;
    name: string;
}

export function _Slider(props: Props) {
    const { storyline, updateParameterValue, name, ...other } = props;
    const [value, setValue] = React.useState(storyline.parameterValues.get(name) || 0);

    const handleChange = (event: any, newValue: number | number[]) => {
        updateParameterValue(name, newValue);
        setValue(newValue);
    };

    React.useEffect(() => {
        
        if (storyline.parameterValues.has(name)) {
            const newValue = storyline.parameterValues.get(name);
            if (newValue !== value) {
                setValue(newValue);
            }
        }
        
    }, [storyline.parameterValues]);

    return (
        <MaterialSlider
            {...other}
            className="slider"
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            onChangeCommitted={handleChange}
            valueLabelDisplay="on"
            color="primary"/>
    );
}

const Slider = connect(
    (state: RootState) => ({
        storyline: state.storyline
    }),
    { updateParameterValue: updateParameterValue as any })(_Slider);

(Slider as DocumentedComponent).metadata = {
    description: "The Slider control allows the user to select a numeric value within a range.  Min/max values and step sizes can be configured.",
    isSelfClosing: true,
    attributes: [
        { name: "name", type: "string", description: "The name of the variable that the selected value will be read from and persisted to." },
    ]
};

export default Slider;